<template>
	<section class="small-12 unitView propertyListingsPage" v-if="property && user">
        <div class="small-12 columns pageTitle flex justify-center">
            <div class="small-12 flex vertical-align">
                <div class="small-12 large-9 columns flex vertical-align">
					<h1 class="auto flex vertical-align">
						Unit Overview 
					</h1>
					<ul class="auto float-left flex vertical-align crumbs">
						<li>
							<span class="round separator bgPrimaryBlue"></span>
						</li>
						<li>
							<p class="small-12 flex vertical-align" v-if="unit">
								<b class="flex">Resident:</b> 
								<router-link :to="{ name: 'Resident', params: { id: $route.params.id, residentID: unit.relationships.resident } }" class="flex vertical-align borderRadius2">
									{{ unit.attributes.resident.first_name }} {{ unit.attributes.resident.last_name }}
									<i class="material-icons border round">chevron_right</i>
								</router-link>
							</p>
						</li>
					</ul>
				</div>
                <div class="small-12 large-3 columns searchContainer">
					<ul class="small-12 flex justify-right vertical-align">
						<li class="addMenu" v-if="user">
							<a class="blueButton flex vertical-align justify-center borderRadius4" @click="openEditUnitMenu()">
								<i class="material-icons-outlined addIcon borderRadius4 flex justify-center vertical-align">edit</i>
								Edit Unit
							</a>
						</li>
					</ul>
				</div>
            </div>
        </div>
        <div class="small-12 flex listingsContainer">
            <section class="small-12 large-8 flex justify-center listings border-right listingsContainerWrap" v-bind:class="{ zIndex: set_index }">
                <div class="small-12 columns" style="margin-top:30px;">
                    <unit-details :unit="unit"/>
					<unit-map :unit="unit" :property="property"/>
                </div>
				<user-footer/>
            </section>
			<section class="small-12 large-4 columns flex overviewPanel" v-bind:class="{ active: open_edit_unit_menu }">
				<div class="small-12 panelBody">
					<unit-resident :unit="unit"/>
				</div>
			</section>
        </div>
    </section>
</template>

<script>

	// Import the mixins
	import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'

    // Import the components
	import UserFooter from '@/components/framework/footer/UserFooter.vue'
    import UnitDetails from '@/components/property/units/UnitDetails.vue'
	import UnitResident from '@/components/property/units/UnitResident.vue'
	import UnitMap from '@/components/property/units/UnitMap.vue'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'UnitView',

		/*
		**  Register the components
		*/

		components: {

			UnitDetails,
			UserFooter,
			UnitResident,
			UnitMap

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			BugsnagService

		],

		/*
		**  Set the props
		*/

		props: {

			user: {
                type: Object,
                default: () => null
            },
            property: {
                type: Object,
                default: () => null
            },
            unit: {
                type: Object,
                default: () => null
            }

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			set_index: false,
			open_edit_unit_menu: false

		}),

		/*
		**  Watch em'
		*/

		watch: {

			prop_name_here: {

				immediate: true, // Load on created
				handler(value) {

					//

				}

			}

		},

		/*
        ** Do this first
        */

        mounted() {

        	//

        },

        /*
		**  Set up the methods
		*/

		methods: {

			//

		},

		/*
		**  Set the computed props
		*/

		computed: {

			//

		},

		/*
		**  Set the filters
		*/

		filters: {

			//

		}

	}

</script>